import { useFormik } from 'formik';
import React from 'react';
import { useSelector } from 'react-redux';
import AdminEditZoneView from '../../../containers/Zones/Admin/AdminEditZone';

const AdminEditZone= () => {
    const {communityInfo:zone } = useSelector(state=>state.userInfo)
    const formik = useFormik({
      enableReinitialize:true,
      initialValues:{
        name:zone.name || '',
        description:zone.description || '',
        category:zone.categoryId || '',
      }
    })

  return <AdminEditZoneView zone={zone} formik={formik} />
};

export default AdminEditZone;
